export default {
  data() {
    return {
      sortField: 'created_at',
      sortDirection: 'desc'
    }
  },
  methods: {
    toggleSort(field, fieldState = 'sortField', directionState = 'sortDirection') {
      if (this[fieldState] === field) {
        this[directionState] = this[directionState] === 'asc' ? 'desc' : 'asc'
      } else {
        this[fieldState] = field
        this[directionState] = 'asc'
      }
    },
    applySort(field, loader) {
      this.toggleSort(field)
      if (Object.prototype.hasOwnProperty.call(this, 'page')) this.page = 1
      if (Object.prototype.hasOwnProperty.call(this, 'currentPage')) this.currentPage = 1
      loader.call(this, 1)
    },
    appendSortParams(params) {
      params.append('sort_field', this.sortField)
      params.append('sort_type', this.sortDirection)
      return params
    },
    sortRows(rows, field, direction) {
      if (!field) return rows

      return this.sortRowsBy(rows, row => row?.[field], direction)
    },
    sortRowsBy(rows, valueGetter, direction) {
      if (typeof valueGetter !== 'function') return rows

      const multiplier = direction === 'desc' ? -1 : 1
      return [...rows].sort((left, right) => {
        const leftValue = valueGetter(left)
        const rightValue = valueGetter(right)

        if (leftValue == null) return rightValue == null ? 0 : 1
        if (rightValue == null) return -1

        const leftNumber = Number(leftValue)
        const rightNumber = Number(rightValue)
        if (leftValue !== '' && rightValue !== '' && Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
          return (leftNumber - rightNumber) * multiplier
        }

        return String(leftValue).localeCompare(String(rightValue), undefined, {
          numeric: true,
          sensitivity: 'base'
        }) * multiplier
      })
    }
  }
}
